import {
    EventComment,
    EventCommentEdit, EventCommentNewApprover,
    EventCommentWithContent
} from "../../../../types/domain.ts";

export const isEditComment = (comment: EventComment): comment is EventComment & EventCommentEdit => comment.type === 'edit';
export const isContentComment = (comment: EventComment): comment is EventComment & EventCommentWithContent => ['custom', 'return', 'request_cancel', 'request_vatrus'].includes(comment.type);
export const isNewApproverComment = (comment: EventComment): comment is EventComment & EventCommentNewApprover => comment.type === 'new_approver';